import { MAIN_MARKETS_TYPE } from 'utils/constants/sportsbook/data-fields';
import { Market } from 'interfaces/sportsbook-data-levels';
import store from 'store';

export const filterFavGroups = (markets: Market[]): Market[] => {
  const IDs = store.getState().favData?.markets || [];

  const objIDs: Record<string, boolean> = {};

  for (const id of IDs) {
    objIDs[id] = true;
  }

  return markets.filter(
    (market: Market): boolean => !!objIDs[`${market.type}-${market.name}`]
  );
};

export const getFavGroupsCount = (markets: Market[]): number => {
  const IDs = store.getState().favData?.markets || [];
  const isMainMarketFavorite = IDs.includes(MAIN_MARKETS_TYPE);

  const objIDs: Record<string, boolean> = {};
  const count = [];

  for (const id of IDs) {
    objIDs[id] = true;
  }

  for (const market of markets) {
    const name = `${market.type}-${market.name}`;

    if (objIDs[name]) {
      count.push(name);
    }
  }

  return new Set(count).size + +isMainMarketFavorite;
};
